export default __webpack_public_path__ + "static/media/Saket.cbe9c584.jpg";